import { Box, BoxProps, forwardRef } from '@chakra-ui/react';

export type Props = BoxProps;

export const Panel = forwardRef<Props, 'div'>((props, ref) => {
  return <Box backgroundColor="white" borderRadius="md" boxShadow="xs" ref={ref} {...props} />;
});
